import { useEffect, useState, useRef } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useNavigate } from 'react-router-dom';
import { useDeleteShopMutation } from 'features/createParticipant/createParticipant';
import { useGetCompetitionsQuery } from '../../../entities/competitions-b2b/api';
import { TableContentForCompetitionsB2B } from '../../../entities/table/ui/TableContentForCompetitionsB2B';
import { retrieveStatus } from '../../../shared/helpers/retriveStatus';
import DrawerCompetition from '../ui/DrawerCompetition';

const fields = [
  {
    field: 'id',
    title: 'ID',
    width: '5%',
  },
  {
    field: 'title',
    title: 'Название',
    width: '20%',
  },
  {
    field: 'status',
    title: 'Статус',
    width: '10%',
  },
  {
    field: 'date_start',
    title: 'Дата начала',
    width: '10%',
  },
  {
    field: 'date_end',
    title: 'Дата завершения',
    width: '10%',
  },
  {
    field: 'participants_count',
    title: 'Участники',
    width: '10%',
  },
];

const CompetitionsListWidget = () => {
  const dispatch = useAppDispatch();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const { data: shopDotsList } = useGetCompetitionsQuery({
    page: pagination.page,
    size: pagination.count,
    search: pagination.search,
  });

  const [removeShopRequest] = useDeleteShopMutation();
  const navigate = useNavigate();

  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  function handleSearch() {
    setPagination((prev) => ({
      ...prev,
      search: searchRef.current,
    }));
  }

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };
  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  const mlist = { list: [] as any };

  if (shopDotsList && shopDotsList.items) {
    shopDotsList?.items.forEach((item) => {
      mlist.list.push({
        id: item.id,
        title: item.name,
        status: item ? retrieveStatus(item.status) : 1,
        date_start: item.date_start,
        date_end: item.date_end,
        participants_count: item.participants_count || 'Участников нет',
      });
    });
  }

  const handleDeleteShop = (id: number) => {
    removeShopRequest(id).then(() => {
      navigate('/shop-dots/');
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  const handleSelect = (id: number) => {
    navigate(`/promo/competitions-b2b/${id}`);
  };

  useEffect(() => {
    dispatch(setHeaderTitle('Список соревнований'));
  }, [dispatch]);

  return (
    <div>
      <TableContentForCompetitionsB2B
        searchPlaceholder="Поиск по названию"
        title="Список соревнований"
        onSearch={() => handleSearch()}
        fields={fields}
        list={{ list: mlist.list }}
        count={shopDotsList?.total ?? 0}
        page={pagination.page - 1}
        perPage={pagination.count}
        onPageChange={(_, page) => {
          setPagination((prev) => ({
            ...prev,
            page: page + 1,
          }));
        }}
        onRowsPerPageChange={(e) => {
          setPagination(() => ({
            page: 1,
            count: parseInt(e.target.value),
            search: pagination.search,
          }));
        }}
        isShowSearch={isShowSearch}
        onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
        onClearSearch={handleClearSearch}
        search={searchQuery.get()}
        setSearch={handleSetSearch}
        onRowClick={handleSelect}
        onDeleteClick={handleDeleteShop}
        onChangeClick={() => {}}
      />

      <DrawerCompetition />
    </div>
  );
};

export { CompetitionsListWidget };
